module.exports = __webpack_public_path__ + "img/full6-min.89b1a1b3.png";